module.exports = __webpack_public_path__ + "img/custom-01.2acdfe6d.png";